import utils from '@/common/utils'
import config from '@/common/config'
export default {
  get_e_user_info,
  get_e_live_list,
  get_e_live_bm,
  get_watch_living_info,
  get_watch_living_detail,
  get_kf_list,
  get_watch_teacher_info,
  get_watch_living_info_new,
  getDepartment,
  getMCN,
  getTeacher,
  updateUserSetting,

  e_live_edit_time,
  e_live_bm_export,
  get_mini_live_url,
  get_chat_records,
}
function get_e_user_info(params) {
  return new Promise((resolve, reject) => {
    var url = config.scrmApi + "api/v1/e_user_info";
    utils.ajax("POST", url, params, 5000).then(function (res) {
      resolve(res)
    }, function (err) {
      reject(err)
    });
  });
}

function callVhProcedure(procedureName, params) {
  return new Promise((resolve, reject) => {
    var baseUrl = config.vhApi || config.livingApi;
    if (baseUrl.charAt(baseUrl.length - 1) !== "/") {
      baseUrl += "/"
    }
    var url = baseUrl + "v1/api/" + procedureName;
    utils.ajax("POST", url, params, 5000).then(function (res) {
      resolve(res)
    }, function (err) {
      reject(err)
    });
  });
}

function get_e_live_list(params, new_url, bmbm) {
  // bmbm 透传给存储过程，用于按部门过滤直播主题
  if (bmbm) {
    params.bmbm = bmbm
  }
  return callVhProcedure("vh_live_list", params);
}

function get_e_live_bm(params, new_url, livetype, bmbm) {
  if (bmbm == "hjsy0312") {
    bmbm = "hjzxsy302"
  }

  params.livetype = livetype
  var procedureName = bmbm && bmbm.indexOf("hjzxsy1") > -1
    ? "vh_live_bm_New_sy1"
    : "vh_live_bm_New";
  return callVhProcedure(procedureName, params);
}

/**
 * 获取部门列表
 */
function getDepartment() {
  return new Promise((resolve, reject) => {
    var url = config.scrmApi + 'api/v1/mcn_deparment_list'
    utils.ajax("GET", url, {}, 5000).then(function (res) {
      resolve(res)
    }, function (err) {
      reject(err)
    })
  })
}

/**
 * 获取MCN列表
 * @param {Object} id 部门ID
 */
function getMCN(id) {
  return new Promise((resolve, reject) => {
    var url = config.scrmApi + 'api/v1/mcn_list2'
    utils.ajax("GET", url, { depart_id: id }, 5000).then(function (res) {
      resolve(res)
    }, function (err) {
      reject(err)
    })
  })
}

/**
 * 获取老师列表
 * @param {Object} name MCN名称
 */
function getTeacher(name) {
  return new Promise((resolve, reject) => {
    var url = config.scrmApi + 'api/v1/mcn_reffer_list'
    utils.ajax("GET", url, { mcn_name: name }, 5000).then(function (res) {
      resolve(res)
    }, function (err) {
      reject(err)
    })
  })
}

function e_live_bm_export(params) {
  return callVhProcedure("vh_live_bm_export", params);
}

function e_live_edit_time(params) {
  return callVhProcedure("vh_live_bm_edit", params);
}

/**
 * 获取客服老师
 */
function get_kf_list() {
  return new Promise((resolve, reject) => {
    var url = config.scrmApi + "api/v1/pro_live_kfname";
    utils.ajax("POST", url, {}, 5000).then(function (res) {
      resolve(res)
    }, function (err) {
      reject(err)
    });
  });
}


/**
 * 获取缴费客户观看直播情况
 * @param {Object} params
 */
function get_watch_living_info(params) {
  return new Promise((resolve, reject) => {
    var url = config.scrmApi + "api/v1/pro_live_kf_list";
    utils.ajax("POST", url, params, 5000).then(function (res) {
      resolve(res)
    }, function (err) {
      reject(err)
    });
  });
}

/**
 * 获取缴费客户观看直播情况
 * @param {Object} params
 */
function get_watch_living_info_new(params) {
  return new Promise((resolve, reject) => {
    var url = config.scrmApi + "api/v1/pro_live_kf_list2";
    utils.ajax("POST", url, params, 5000).then(function (res) {
      resolve(res)
    }, function (err) {
      reject(err)
    });
  });
}

function get_watch_living_detail(params) {
  return new Promise((resolve, reject) => {
    var url = config.scrmApi + "api/v1/pro_live_kf_detail";
    utils.ajax("POST", url, params, 5000).then(function (res) {
      resolve(res)
    }, function (err) {
      reject(err)
    });
  });
}

function get_watch_teacher_info(params) {
  return new Promise((resolve, reject) => {
    var url = config.scrmApi + "api/v1/pro_live_group";
    utils.ajax("POST", url, params, 5000).then(function (res) {
      resolve(res)
    }, function (err) {
      reject(err)
    });
  });
}

/**
 * 更新用户设置（备注和用户类型）
 * @param {Object} params 包含unionid、remark、userType
 */
function updateUserSetting(params) {
  return new Promise((resolve, reject) => {
    var url = config.scrmApi + "api/v1/sp_contact_other";
    utils.ajax("POST", url, params, 5000).then(function (res) {
      resolve(res)
    }, function (err) {
      reject(err)
    });
  });
}

/**
 * 获取小程序打开URL
 * @param {*} params 
 * @returns 
 */
function get_mini_live_url(bmbm, params) {
  return new Promise((resolve, reject) => {
    // var url = config.scrmApi + "api/v1/e_user_info";
    let url = ""
    if (bmbm == "hjsy0312") {
      bmbm = "hjzxsy302"
    }
    
    url = "https://vhall-data.qiankuncloud-ai.com/v1/api/urllink"
    
    utils.ajax("POST", url, params, 5000).then(function (res) {
      resolve(res)
    }, function (err) {
      reject(err)
    });
  });
}

/**
 * 查询指定用户在指定直播间的聊天记录
 * @param {Object} params 包含 unionid、livingid、page、page_size
 * @returns Promise
 */
function get_chat_records(params) {
  return new Promise((resolve, reject) => {
    var baseUrl = config.vhApi || config.livingApi;
    if (baseUrl.charAt(baseUrl.length - 1) !== "/") {
      baseUrl += "/"
    }
    var url = baseUrl + "v1/api/get_chat_records";
    utils.ajax("POST", url, params, 10000).then(function (res) {
      resolve(res)
    }, function (err) {
      reject(err)
    });
  });
}
